import { useEffect, useState } from "react";
import { getCalendar } from "../../request/calendar";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  Box,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Popover,
  Select,
  Typography,
  Checkbox,
} from "@mui/material";
moment.updateLocale("en", { week: { dow: 1 } });
const localizer = momentLocalizer(moment);

export function getColorClassName(name) {
  return (
    "custom-color-" +
    (name ? name.toLowerCase().replace(" ", "-") : "undefined")
  );
}

export default function CalendarPage() {
  const [calendar, setCalendar] = useState(null);
  const [types, setTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [emails, setEmails] = useState([]);
  const [filterTypes, setFilterTypes] = useState([]);
  const [filterLocations, setFilterLocations] = useState([]);
  const [filterEmails, setFilterEmails] = useState([]);
  const [filterOnBoarding, setFilterOnBoarding] = useState(["Yes", "No"]);

  const formatEvent = (backendRow) => {
    return {
      ...backendRow,
      //id: backendRow.date + backendRow.email,
      title: (
        <Title event={backendRow} key={backendRow.date + backendRow.email} />
      ),
      allDay: true,
      start: moment(backendRow.date, "DD.MM.YYYY"),
      end: moment(backendRow.date, "DD.MM.YYYY"),
    };
  };

  const eventStyleGetter = (event) => {
    return {
      className:
        getColorClassName(event.type) +
        " " +
        " loc-" +
        getColorClassName(event.location),
      style: {
        //backgroundColor: event?.type_color,
      },
    };
  };

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  //set unique selects
  useEffect(() => {
    if (calendar?.length > 0) {
      if (types.length === 0) {
        const uniqueTypes = calendar
          .map((row) => row.type ?? null)
          .filter(onlyUnique);
        setTypes(uniqueTypes);
      }
      if (locations.length === 0) {
        const uniqueLocations = calendar
          .map((row) => row.location ?? null)
          .filter(onlyUnique);
        setLocations(uniqueLocations);
      }
      if (emails.length === 0) {
        const uniqueEmails = calendar
          .map((row) => row.email ?? null)
          .filter(onlyUnique);
        setEmails(uniqueEmails);
      }
    }
  }, [calendar]);

  //Load calendar rows
  useEffect(() => {
    if (calendar === null) {
      const filter = {};
      if (filterTypes.length > 0) {
        filter["type"] = filterTypes.join(",");
      }
      if (filterLocations.length > 0) {
        filter["location"] = filterLocations.join(",");
      }
      if (filterEmails.length > 0) {
        filter["email"] = filterEmails.join(",");
      }
      if (filterOnBoarding.length > 0) {
        filter["onboarding"] = filterOnBoarding
          .map((value) => (value === "Yes" ? 1 : 0))
          .join(",");
      }
      getCalendar(null, filter)
        .then(({ status, data }) => {
          if (status === 200) {
            const formatted = data.map((row) => formatEvent(row));
            setCalendar(formatted);
          } else {
            alert("error downloading calendar, please reload page");
          }
        })
        .catch((err) => console.error(err));
    }
  }, [calendar]);

  const handleChange = (event, updateMethod) => {
    const {
      target: { value },
    } = event;
    updateMethod(typeof value === "string" ? value.split(",") : value);
    setCalendar(null);
  };

  return (
    <>
      <Box>
        {types.length > 0 && (
          <ShowSelect
            items={types}
            currentValues={filterTypes}
            title={"Types"}
            handleChange={(event) => handleChange(event, setFilterTypes)}
          />
        )}
        {locations.length > 0 && (
          <ShowSelect
            items={locations}
            currentValues={filterLocations}
            title={"Locations"}
            handleChange={(event) => handleChange(event, setFilterLocations)}
          />
        )}
        {emails.length > 0 && (
          <ShowSelect
            items={emails}
            currentValues={filterEmails}
            title={"Employees"}
            handleChange={(event) => handleChange(event, setFilterEmails)}
          />
        )}
        {
          <ShowSelect
            items={["Yes", "No"]}
            currentValues={filterOnBoarding}
            title={"Onboarding"}
            handleChange={(event) => handleChange(event, setFilterOnBoarding)}
          />
        }
      </Box>
      {Array.isArray(calendar) && (
        <Calendar
          localizer={localizer}
          events={calendar}
          startAccessor="start"
          endAccessor="end"
          style={{ minHeight: 2000, width: "100%" }}
          eventPropGetter={eventStyleGetter}
          views={["month"]}
          showAllEvents={true}
        />
      )}
    </>
  );
}

function ShowSelect(props) {
  const { items, currentValues, title, handleChange } = props;

  return (
    <>
      {items?.length > 0 && (
        <FormControl size="small" sx={{ m: 1, width: 300 }}>
          <InputLabel>{title}</InputLabel>
          <Select
            multiple
            value={currentValues}
            onChange={handleChange}
            input={<OutlinedInput label="Tag" />}
            renderValue={(selected) => selected.join(", ")}
          >
            {items.map((name) => (
              <MenuItem
                key={name}
                value={name}
                className={getColorClassName(name)}
              >
                <Checkbox size="small" checked={currentValues.includes(name)} />
                <ListItemText size="small" primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
}

function Title(props) {
  const { event } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <Typography onClick={handleClick} fontSize={12}>
        <Box
          component="span"
          className={getColorClassName(event?.location)}
          sx={{ display: "inline-block" }}
        >
          {event?.location ? `[${event?.location}]` : ""}
        </Box>
        {event.onboarding && (
          <Box
            component="span"
            sx={{ display: "inline-block" }}
            className={getColorClassName("onb")}
          >
            [{"OnB"}]
          </Box>
        )}
        {" " + event?.email}
      </Typography>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography className={getColorClassName(event.type)}>
            Type: {event.type}
          </Typography>
          <Typography className={getColorClassName(event.location)}>
            Location: {event.location}
          </Typography>
          <Typography>Date: {event.date}</Typography>
          <Typography>Email: {event.email}</Typography>
          <Typography>
            Time: {event.timeStart} - {event.timeEnd}
          </Typography>
          <Typography
            className={event.onboarding ? getColorClassName("onb") : ""}
          >
            Onboarding: {event.onboarding ? "Yes" : "No"}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}
